import { render, staticRenderFns } from "./GroupPermissionOverview.vue?vue&type=template&id=2da40b2c&scoped=true&"
import script from "./GroupPermissionOverview.vue?vue&type=script&lang=js&"
export * from "./GroupPermissionOverview.vue?vue&type=script&lang=js&"
import style0 from "./GroupPermissionOverview.vue?vue&type=style&index=0&id=2da40b2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da40b2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDialog,VIcon,VSpacer})
